/* eslint-disable react/display-name */
import { TypedColumn } from '../dataGrid/TypedDataGridInterfaces';
import { createCertificationColumnFormatter } from './certification/CertificationColumnFormatter';
import { UseRenderLabelsParams } from './hook/useRenderLabels';
import { createSensitivityColumnFormatter } from './sensitivity/SensitivityColumnFormatter';
import { LabelColumnFormatterParams } from './shared/LabelCellFormatterParams';
import { createWarningColumnFormatter } from './warning/WarningColumnFormatter';


export function createLabelColumnFormatter<T,>(category: 'warning' | 'certification' | 'sensitivity', props: LabelColumnFormatterParams<T, UseRenderLabelsParams>): TypedColumn<T, ''> {
  switch (category) {
    case 'warning': return createWarningColumnFormatter(props);
    case 'certification': return createCertificationColumnFormatter(props);
    case 'sensitivity': return createSensitivityColumnFormatter(props);
  }
}
